export const allowedLocales = ['en', 'he', 'ar'];
